<template>
  <div
    class="main--text">
    <v-container
      fluid>
    <v-row
      justify=end
      >
      <v-col
        cols=auto>
        <v-tooltip
          left
          >
          <template
            v-slot:activator="{ on }"
            >
            <v-btn
              fab
              dark
              small
              right
              color="pink"
              v-on="on"
              @click="toStudentProfileSetting"
              ><v-icon>mdi-plus</v-icon>
            </v-btn>
          </template>
          <span
            class="main--text">お子さまの情報を登録</span>
        </v-tooltip>
      </v-col>
    </v-row>
    </v-container>
    <v-container
      fluid
      grid-list-md
      grid-list-xs
      class="no--vertical--paddings"
      >
      <h3>お子さま一覧</h3>
      <v-layout
        justify-start
        wrap
        >
        <v-flex
          md4
          sm6
          xs12
          v-for="(student, index) in students.get()"
          :key="index"
          >
          <v-student-card
            :student="student"
            @info-button-click="toStudent(student)"
            @delete-button-click="confirmDelete(student.id)"/>
        </v-flex>
      </v-layout>
      <v-layout
        justify-center
        v-if="students.length() === 0">
        <v-flex
          md8
          sm8
          xs10>
          <v-card>
            <v-container
              fluid>
              <v-layout>
                <v-flex
                  class="main--text">
                  お子さまを登録してください。
                </v-flex>
              </v-layout>
            </v-container>
          </v-card>
        </v-flex>
      </v-layout>
    </v-container>
    <v-student-delete-confirm
      v-model="confirmDialog"
      @close-button-click="confirmDialog=false"
      @confirm-button-click="deleteStudent(selectedStudentId)"/>
    <v-snackbar
      v-model="deleted"
      top>
      <span>お子さまの登録を解除しました</span>
      <v-btn
        dark
        text
        @click="deleted=false">閉じる
      </v-btn>
    </v-snackbar>
    <v-error-dialog
      v-model="error"
      :message="errorMessage"
      />
    <v-progress
      v-model="inProgress"/>
  </div>
</template>

<script>
import { firestore } from "@/repository/client/firestore"
import { StudentDeleter } from '@/service/student/delete-student'
import VStudentCard from "@/components/organisms/parent/VStudentCard.vue"
import VStudentDeleteConfirm from '@/components/organisms/parent/VStudentDeleteConfirm.vue'
import VErrorDialog from '@/components/organisms/parent/VErrorDialog.vue'
import VProgress from '@/components/organisms/VProgress.vue'

export default {
  components: {
    VStudentCard,
    VStudentDeleteConfirm,
    VErrorDialog,
    VProgress
  },
  data() {
    return {
      parent: this.$store.getters.parent,
      students: this.$store.getters.parent.students,
      confirmDialog: false,
      selectedStudentId: null,
      deleted: false,
      inProgress: false,
      error: false,
      errorMessage: ""
    }
  },
  methods: {
    toStudentProfileSetting () {
      this.$router.push({name: 'studentProfileSetting', params: {'id': this.$store.getters.parent.uuid}})
    },
    toStudent(student) {
      this.$router.push({name: "studentBase", params: {'id': this.$store.getters.parent.uuid, 'studentId': student.id}})
    },
    confirmDelete(studentId) {
      this.selectedStudentId = studentId
      this.confirmDialog = true
    },
    async deleteStudent(studentId) {
      this.confirmDialog = false
      this.inProgress = true
      try {
        const deleter = new StudentDeleter(firestore, this.parent)
        this.parent = await deleter.execute(studentId)
        this.$store.commit('loginAsParent', this.parent)
        this.inProgress = false
        this.deleted = true
      } catch (e) {
        this.errorMessage = e.message
        this.inProgress = false
        this.error = true
      }
    }
  }
}
</script>

<style scoped>
.no--vertical--paddings {
  padding: 0px 12px;
}
</style>
